<div class="sidebar" [class.collapsed]="isSidebarCollapsed" [ngClass]="customClass">
  <ion-button fill="clear" (click)="toggleSidebar()" class="collapse-btn">
    <ion-icon [name]="isSidebarCollapsed ? 'chevron-forward-outline' : 'chevron-back-outline'"></ion-icon>
  </ion-button>
  <div class="sidebar-innerWrapper">
    <div class="logoWrapper">
      <app-logo customClass="sideBarLogo" [variant]="isSidebarCollapsed ? 'mini' : 'full'"></app-logo>
    </div>
    <!-- Sidebar nav -->
    <div class="menuContent">
      <ion-list class="nav-content" lines="none">
        <!-- <ion-item lines="none">
              <div class="logoWrapper">
                <app-logo customClass="sideBarLogo" [variant]="isSidebarCollapsed ? 'mini' : 'full'"></app-logo>
              </div>
            </ion-item> -->
        <ion-item lines="none" button class="menuElement menuLink" (click)="closeSidebarOnClick()"
          [routerLink]="menu.link" routerLinkActive="active" *ngFor="let menu of sideBarMenus">
          <!-- <ion-img [src]="menu.icon" alt="{{menu.title}}" class="sidebar-icon"></ion-img> -->
          <span class="menuHeadIconWrapper" [innerHTML]="menu.linkIcon" [ngClass]="{'special':menu.specialFlag}"></span>
          <ion-label *ngIf="!isSidebarCollapsed">{{menu.title}}</ion-label>
        </ion-item>
        <!-- <ion-item lines="none" button class="menuElement menuLink" routerLink="/dashboard" routerLinkActive="active">
          <ion-icon name="grid-outline" slot="start" color="customPrimary"></ion-icon>
          <ion-img src="assets/images/sidebar/Offers.svg" alt="Dashboard" class="sidebar-icon"></ion-img>
          <ion-label *ngIf="!isSidebarCollapsed">Dashboard</ion-label>
        </ion-item> -->

      </ion-list>
      <div class="flex-spacer"></div>
      <!-- <ion-img src="assets/images/bgImages/graphGrowth.svg" alt="Finance Logic" class="sidebar-bgImg"
        *ngIf="!isSidebarCollapsed"></ion-img> -->
      <div class="sidebar-bgImgWrapper" *ngIf="!isSidebarCollapsed">
        <span [innerHTML]="sidebarBgImage" class="sidebar-bgImg"></span>
      </div>
      <div class="nav-content sidebar-footer">
        <ion-item lines="none" button class="menuElement menuLink logoutItem" (click)="logout()">
          <ion-img src="assets/images/sidebar/logoutIcon.svg" alt="Logout" class="sidebar-icon"></ion-img>
          <ion-label>Logout</ion-label>
        </ion-item>
        <ion-item lines="none" class="version-item menuElement">
          <ion-label class="version">
            {{isSidebarCollapsed? 'V 0.1.0': 'Version 1.0.0'}}
          </ion-label>
        </ion-item>
      </div>
    </div>
  </div>
</div>